<template>
    <div class="special">
        <div class="special-banner">
            <!-- <img :src="" alt=""> -->
            <!-- <img src="../../../assets/special_banner.png" alt=""> -->
        </div>
        <div class="special-content flex">
            <div class="special-item cursor" v-for="(items,index) in list" @click="toSearchTopic(items)">
                <img :src="items.topicImg" alt="" v-if="items.topicImg">
                <img src="https://v.libraryplus.bjadks.com/java/mrms/publicImg/special-list-default.png" alt="" v-else>
                <p class="title text-line-1">{{items.topicName}}</p>
                <p class="description text-line-2">{{items.description}}</p>
                <p class="date">{{items.createTime}}</p>
            </div>
        </div>
        <div class="dashboard-bottom">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage"  :hide-on-single-page="false" :page-size="pageSize" layout="total, prev, pager, next" :total="totalSize">
            </el-pagination>      
        </div>
    </div>
</template>
<script>
    import searchModel from "@/models/search.js";
    import {
        getTopicPage
    } from '@/api/special'
    export default{
        data() {
            return{
                totalSize: 1,
                currentPage: 1,
                pageSize: 24,
                list:[],
                options:{}
            }
        },
        mounted() {
            this.getTopicPage()
        },
        methods:{
            // toLookInfor(row) {
            //     this.$router.push({
            //         path: '/information/publish',
            //         query: {
            //         id: row.id

            //         }
            //     })
            // },
                // 特色专题 更多
            toSearchTopic(v) {
                this.$store.dispatch("search/setType", 1);
                this.$store.dispatch("search/setKeyword", "");
                searchModel.viewData = {
                    params: { specialSubject: v.id },
                    display: v.topicName,
                    type: "specialSubject"
                };
                this.$router.push({ 
                    name: "Specialdetail",  
                    query: {
                        id: v.id
                    } 
                });
                console.log("v.id",v.id);
            },

            async getTopicPage() {
                this.options.current = this.currentPage
                this.options.size = this.pageSize
                this.options.tenantId  = this.$store.getters.tenantId
                const res = await getTopicPage(this.options)
                console.log('res', res)
                this.loading = false
                this.totalSize = res.data.total
                this.list = res.data.records
            },
            handleSizeChange(val) {
                this.pageSize = val
                window.scrollTo(0, 0)
                this.getTopicPage()
            },
            handleCurrentChange(val) {
                this.currentPage = val
                window.scrollTo(0, 0)
                this.getTopicPage()
            }
        }
    }
</script>
<style src="@/styles/pc.css" scoped>
</style>
<style lang="scss" scoped>
    .special-banner {
        background-repeat: no-repeat !important;
        margin-top: 70px;
        margin-bottom: 40px;
        height: 400px;
        background-color: #ddd;
        background: url("../../../assets/special_banner.png") no-repeat;
        background-size: 100% 100%;
        background-position: center !important;
    }
    .special-banner img{
        width: 100%;
        height: 400px;
    }
    .special-content{
        width: 1240px;
        margin: 0 auto; 
        flex-wrap: wrap;
    }
    .special-item {
        width: 400px;
        height: 290px; 
        margin-right:  20px;
        margin-bottom:  40px;
        overflow: hidden;
    }
    .special-item:nth-child(3n){
        margin-right: 0px;
    }
    .special-item img{
        width: 768px;
        margin-bottom: 20px;
        height: 160px;
        background-color: #eee;
        opacity: .9;
        margin-left: -184px;
    }
    .special-item .title{
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        color: #3D3D3D;
        font-weight: bold;
    }
    .special-item .description{
        height: 40px;
        line-height: 20px;
        margin-bottom: 10px;
        font-size: 12px;
        color: #999999;
    }
    .special-item .date{
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: #999999;
        
    }
    .dashboard-bottom{
        display: flex;
        margin-top: 20px;
        align-items: center;
        /* justify-content: space-between; */
        flex-direction: row-reverse;
        margin-bottom: 20px;
    }
</style>